import { Box, Button } from "@chakra-ui/react";
import { useCSVExport } from "../../hooks/useCSVExports";
import { ExportCSVProps } from "../../interface/interface";

const ExportCSV: React.FC<ExportCSVProps> = ({ products }) => {
  const { handleExport } = useCSVExport(products);

  return (
    <Box>
      <Button onClick={handleExport}>Export to CSV</Button>
    </Box>
  );
};

export { ExportCSV };
